var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3199 11.0181L9.37844 5.9596C10.0093 5.32876 11.0321 5.32876 11.6629 5.95961V5.95961C12.2938 6.59045 12.2938 7.61326 11.6629 8.2441L6.6044 13.3026C5.34271 14.5643 3.2971 14.5643 2.0354 13.3026V13.3026V13.3026C0.77371 12.0409 0.77371 9.99533 2.0354 8.73364L8.07301 2.69604C9.96555 0.803495 13.034 0.803494 14.9265 2.69604V2.69604C16.819 4.58858 16.819 7.65699 14.9265 9.54953L8.8889 15.5871",
    stroke: "#484848",
    strokeWidth: 1.38462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6bcf7d4cd086036278c102a84d78269e.svg";
export { ForwardRef as ReactComponent };